import { SortOrder } from '@approvalmax/ui/src/components';

import { SortingDirection } from '../../types/SortingDirection';

export const mapSortOrdersFromLegacy = (sortOrder: SortingDirection | null) => {
    return sortOrder === SortingDirection.Descending ? SortOrder.desc : SortOrder.asc;
};

export const mapSortOrdersToLegacy = (sortOrder: SortOrder | null) => {
    return sortOrder === SortOrder.desc ? SortingDirection.Descending : SortingDirection.Ascending;
};
